<div class="row">

    <div class="col-sm-12" style="padding-right: 0px;">
        <div class="alert alert-success" role="alert" style="margin-top: 5px">
            <h4 class="alert-heading"><fa-icon class="button-icon-left" [icon]="faCircleInfo"></fa-icon>Support Site</h4>
            <p>
                Our <a href="https://support.tinselcrm.com" target="_blank">Support Documentation site</a> is a comprehensive repository of information, guides, FAQs, and troubleshooting steps
                that cover a wide range of topics related to our products and services. It's designed to provide you with quick and
                easy solutions to common issues and answers to frequently asked questions.
            </p>
            <hr>
            <p>Before creating a New Ticket, you should check the Support Site first. The answer to your question may be just a few clicks away!</p>
            <a href="https://support.tinselcrm.com" target="_blank" type="button" class="btn btn-primary">Visit The Support Site</a>
        </div>
    </div>
    <div class="col-sm-12">
        <div class="card">
            <div *ngIf="!isOpenFromModal" class="card-header d-flex">
                <h5>{{ bugReport ? capitalizeFirstLetter(bugReport.supportType.toLowerCase()) :'New' }} Ticket
                    <span *ngIf="bugReport"><i>({{ bugReport.id }})</i></span>
                </h5>
                <button (click)="newTicket()" type="button" class="btn btn-primary ms-auto"><fa-icon class="button-icon-left" [icon]="faPlus"></fa-icon> New Ticket</button>
            </div>
            <div class="card-body">
                <form [formGroup]="bugReportForm">
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <label for="USER_NAME">Name</label>
                            <input id="USER_NAME" [readonly]="bugReport" type="text" class="form-control" formControlName="name" placeholder="John Doe" maxlength="150" [class.is-invalid]="name_validators?.invalid && (name_validators?.touched || name_validators?.dirty)">
                            <div *ngIf="name_validators?.invalid && (name_validators?.touched || name_validators?.dirty)">
                                <small *ngIf="name_validators?.errors?.required" class="text-danger">Name is required.</small>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-3">
                            <label for="USER_COMPANY">Company</label>
                            <input id="USER_COMPANY" readonly type="text" class="form-control" formControlName="companyName" placeholder="ABC Corp" maxlength="150">
                        </div>
                        <div class="col-lg-6 mb-3">
                            <label for="USER_PHONE">Phone</label>
                            <input id="USER_PHONE" [readonly]="bugReport" type="text" class="form-control" formControlName="phone" placeholder="+1 123 456 7890" maxlength="150">
                        </div>
                        <div class="col-lg-6 mb-3">
                            <label for="USER_EMAIL">Email</label>
                            <input id="USER_EMAIL" [readonly]="bugReport" type="text" class="form-control" formControlName="email" placeholder="john.doe@example.com" maxlength="150">
                        </div>
                        <div class="col-lg-12 mb-3">
                            <label for="SUPPORT_TYPE">How can we help you?</label>
                            <select id="SUPPORT_TYPE" class="form-select" formControlName="supportType" [ngClass]="[!bugReportForm.controls['supportType'].value ? 'no-support-type' : '', bugReport ? 'disabled-class': '']">
                                <option [ngValue]="null" disabled selected hidden>Select Category</option>
                                <option *ngFor="let supp of supportType" [value]="supp.value">{{ supp.name }}</option>
                            </select>
                            <div *ngIf="supportType_validators?.invalid && (supportType_validators?.touched || supportType_validators?.dirty)">
                                <small *ngIf="supportType_validators?.errors?.required" class="text-danger">Please select a category.</small>
                            </div>
                        </div>
                        <div *ngIf="bugReportForm.controls['supportType'].value" class="col-lg-12 mb-3">
                            <label for="USER_TITLE">Title</label>
                            <input id="USER_TITLE" [readonly]="bugReport" type="text" class="form-control" formControlName="title" [placeholder]="bugReportForm.controls['supportType'].value == 'FEATURE' ? 'Feature request' : 'Title'" maxlength="150">
                        </div>
                        <div *ngIf="bugReportForm.controls['supportType'].value" class="col-lg-12 mb-3">
                            <label for="USER_DESCRIPTION">Description</label>
                            <textarea id="USER_DESCRIPTION" [readonly]="bugReport" class="form-control" formControlName="description" style="height: 173px; resize: none;" [placeholder]="bugReportForm.controls['supportType'].value == 'BUG' ? 'Describe the issue' : 'Description'" maxlength="65535"></textarea>
                        </div>
                        <div *ngIf="bugReportForm.controls['supportType'].value == 'BUG'" class="col-lg-12 mb-3">
                            <label for="USER_STEPS">Steps to reproduce</label>
                            <textarea id="USER_STEPS" [readonly]="bugReport" class="form-control" formControlName="steps" style="height: 173px; resize: none;" placeholder="What steps did you take that caused the issue?" maxlength="65535"></textarea>
                        </div>
                        <div *ngIf="bugReportForm.controls['supportType'].value == 'BUG' && !bugReport" class="col-lg-12 mb-3">
                            <label for="USER_DATETIME">Date/Time of Bug</label>
                            <input id="USER_DATETIME" type="datetime-local" class="form-control" formControlName="dateTimeBug">
                        </div>
                        <div *ngIf="bugReportForm.controls['supportType'].value == 'bg-auto' && bugReport" class="col-lg-12 mb-3">
                            <label for="USER_AUTO_DATETIME">Date/Time Bug</label>
                            <input id="USER_AUTO_DATETIME" [readonly]="bugReport" type="text" class="form-control" formControlName="dateTimeBug" placeholder="Date/Time Bug" maxlength="150">
                        </div>
                        <div *ngIf="bugReportForm.controls['supportType'].value == 'BUG'" class="col-lg-12 mb-3">
                            <label for="USER_URL">Page URL</label>
                            <input id="USER_URL" [readonly]="bugReport" type="text" class="form-control" formControlName="url" placeholder="https://example.com/issue-page" maxlength="150">
                        </div>
                        <div *ngIf="bugReportForm.controls['supportType'].value == 'BUG'" class="col-lg-12 mb-3">
                            <label for="USER_FILE">Attachments</label>
                            <input id="USER_FILE" [ngClass]="[bugReport ? 'disabled-class': '']" type="file" class="form-control" (change)="onFileChangeEvent($event)" multiple />
                            <small class="upload-description">*Only 3 files allowed and maximum of 3 MB each</small>
                            <div class="row mb-3">
                                <div class="col-lg-12">
                                    <button [disabled]="bugReport" *ngFor="let file of fileArray; let i = index" (click)="removeImageInArray(i)" type="button" class="btn btn-chip">
                                        {{file.filename}} <fa-icon [icon]="faTimes"></fa-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!isOpenFromModal" class="col-lg-12">
                            <div class="float-end">
                                <button [disabled]="!bugReportForm.valid" type="button" class="btn btn-primary" (click)="addBugReport();">Submit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<!-- </div>
    </div>
</div> -->
